import { render, staticRenderFns } from "./customers.vue?vue&type=template&id=30bd0ea0&scoped=true"
import script from "./customers.vue?vue&type=script&lang=js"
export * from "./customers.vue?vue&type=script&lang=js"
import style0 from "./customers.vue?vue&type=style&index=0&id=30bd0ea0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30bd0ea0",
  null
  
)

export default component.exports